/*
 * @Description: 中文
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2019-11-25 14:51:17
 * @LastEditors: 山淑兰
 */
export default {
    language: {
      name: 'English'
    },
    meeting:{
      header:{
        search:{
          placeholder:'请输入姓名、单位查询',
		  sort: '按姓氏首字母排序',
          selectDate:'选择日期',
          selectVenue:'选择会场',
          agenda:'会议日程',
          task:'会议任务',
          guestIntroduction:'嘉宾介绍',


        }
      },
      details:{
        guestsIntroductionTitle:"嘉宾简介",
        guestsIntroduction:"暂无简介"
        
      }
    }
  }